module.exports = __webpack_public_path__ + "static/img/selected2@2x.0ac22cf3.png";